module.exports = __webpack_public_path__ + "static/media/is.7d3e4b12.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/is.svg
// module id = 2121
// module chunks = 0